// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"wn_a bic_b bic_we"};